export const ENTRY_TYPE_FOLDER = 'folder' as const;
export const ENTRY_TYPE_FILE = 'file' as const;

export type EntryType = typeof ENTRY_TYPE_FOLDER | typeof ENTRY_TYPE_FILE;


